module.exports = __webpack_public_path__ + "img/Adv_raw_numbers-300x128.209cb92b.png";